import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import grouplocationApi from 'api/grouplocationApi'

export const thunkGrounplocation = createAsyncThunk(
  'groupLocation/getAll',
  async (param, thunkApi) => {
    try {
      const res = await grouplocationApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'groupLocation',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkGrounplocation.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkGrounplocation.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
